import React from "react";
import { Auth } from "redux-server-connection";
import { Link } from "react-router-dom";

import catalogo_ufs from "../../assets/catalogo_ufs.jpg";
import catalogo_profesional from "../../assets/catalogo_profesional.jpg";
import "./styles.css";

const Render = (props, context) => {
  const loggedUser = Auth.getUser();
  return (
    <section className="catalogo int backgroundImage">
      <div className="">
        {(!loggedUser.uy) && (
          <div key="ufs_alone" className="borderBox tarjetaCatalogoSimple clearfix" >
            <div className="img pRel mask mha imgContainer total">
              <img src={catalogo_ufs} className="horizontalCenter catalogo-portada displayBlock" alt="Descargar catálogo Food Solutions" />
            </div>
            <Link target="_blank"
                          to={`/catalogo/catalogo_ufs.pdf`}
                          className={`btn btnGold displayBlock avenirBK bold fontGold horizontalCenter ma`}
                        >
                          Descargar catálogo
                        </Link>
          </div>
        )}
        {(loggedUser.uy) && (
          <div key="ufs_alone" className="borderBox tarjetaCatalogoSimple clearfix" >
            <div className="img pRel mask mha imgContainer total">
              <img src={catalogo_ufs} className="horizontalCenter catalogo-portada displayBlock" alt="Descargar catálogo Food Solutions" />
            </div>
            <Link target="_blank"
                          to={`/catalogo/catalogo_ufs_uruguay.pdf`}
                          className={`btn btnGold displayBlock avenirBK bold fontGold horizontalCenter ma`}
                        >
                          Descargar catálogo
                        </Link>
          </div>
        )}
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Catalogo/Render.js